import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import { fetchPartnersData } from "../../../redux/partners/index";
import { Avatar, Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import TableView from "../../../components/Table/TableView";
import { Typography } from "@material-ui/core";

export default () => {
	const partnersData = useSelector((state) => state.partnersGlobalStore);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchPartnersData());
	}, []);

	const headCells = [
		{
			id: "name",
			numeric: false,
			label: "Partner Name",
		},
		{
			id: "status",
			numeric: true,
			label: "Status",
		},
		{
			id: "url",
			numeric: true,
			label: "Partner Address",
		},
		,
	];

	console.log("partnersData", partnersData);

	const rows =
		partnersData.data.data?.map((el) => ({
			name: (
				<div className="make_column_title">
					<Avatar variant="rounded" src={el.pictureUrl} />
					<Typography>{el.name}</Typography>
				</div>
			),
			status: el.status,
			url: el.weblink,
			link: `/partners/${el?.id}`,
		})) || [];

	return (
		<div>
			{partnersData.loading && !partnersData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							float: "right",
						}}
					>
						<Button
							component={NavLink}
							to="/partners/new"
							variant="outlined"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add new Partner
						</Button>
					</div>
					<div>
						<TableView
							dense
							headCells={headCells}
							rows={rows}
							title="Partners"
						/>
					</div>
				</>
			)}
		</div>
	);
};
